/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
/*------------------------------------*\
    Calendar
\*------------------------------------*/
class Calendar {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        let prevBtn = document.getElementById('prevBtn');
        let nextBtn = document.getElementById('nextBtn');
        let currentMonth = $('.calendar__head').find('.active');

        var id = currentMonth[0].id;
        var minId = 0;
        var maxId = 23;

        prevBtn.addEventListener('click', evt => {
            id = Math.max(Number(id) - 1, minId);

            if (id >= minId) {
                $('.calendar__head').find('.active').removeClass('active');
                $('.calendar__body').find('.active').removeClass('active');

                document.getElementById(id).classList.toggle('active');
                document.getElementById('calendarBody'+id).classList.toggle('active');
            }
        });

        nextBtn.addEventListener('click', evt => {
            id = Math.min(Number(id) + 1, maxId);

            if (id <= maxId) {
                $('.calendar__head').find('.active').removeClass('active');
                $('.calendar__body').find('.active').removeClass('active');

                document.getElementById(id).classList.toggle('active');
                document.getElementById('calendarBody'+id).classList.toggle('active');
            }
        });

        self.catalogues();
    }

    catalogues() {
        let self = this;
        let rows = self.elem.getElementsByClassName('table-dates__row');
        let btn = document.getElementById('catalogueBtn');

        var items = [];

        Array.prototype.remove = function() {
            var what, a = arguments, L = a.length, ax;

            while (L && this.length) {
                what = a[--L];
                while ((ax = this.indexOf(what)) !== -1) {
                    this.splice(ax, 1);
                }
            }

            return this;
        };

        Array.prototype.forEach.call(rows, function(row) {
            let el = row.getElementsByClassName('form-check-input');

            if(el.length > 0) {
                el[0].addEventListener('click', evt => {
                    let value = el[0].value;

                    if (el[0].checked) {
                        row.classList.add('active');
                        btn.classList.add('active');
                        items.push(value);
                        self.createHtml(value);
                    } else {
                        row.classList.remove('active');
                        items.remove(value);
                        self.removeHtml(value);
                    }
                });
            }
        });
    }

    createHtml(value) {
        let self = this;
        let element = document.getElementById('catalogueList');
        let ul = element.getElementsByTagName('ul');
        let li = document.createElement('li');

        ul[0].appendChild(li);
        li.innerHTML += value;
    }

    removeHtml(value) {
        let self = this;
        let element = document.getElementById('catalogueList');
        let ul = element.getElementsByTagName('ul');
        let li = element.getElementsByTagName('li');

        Array.prototype.forEach.call(li, function(item) {
            if (item.innerText == value) {
                item.remove();
            }
        });
    }
}

export default Calendar;
